import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { initSupabaseClient } from '@leoclinic/services';
import { ClinicProvider } from '@/providers/clinic-provider';
import { router } from '@/router';
import './index.css';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;
if (supabaseUrl && supabaseKey) {
  initSupabaseClient({ url: supabaseUrl, anonKey: supabaseKey });
}

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ClinicProvider>
        <RouterProvider router={router} />
      </ClinicProvider>
    </QueryClientProvider>
  </StrictMode>,
);
